export default __webpack_public_path__ + "static/media/WM-FL_2020_seemore01_NA-S106FX1_VN_201012-vn.e9d0a1e7.jpg";